import { Background, BackgroundVariant } from '@xyflow/react';

export const ReactFlowBackgroundColor = '#F2F3F6';

interface ReactFlowBackgroundProps {
  borderRadiusInPixels?: number;
  borderMode?: 'none' | 'solid';
}

export function ReactFlowBackground(props: ReactFlowBackgroundProps) {
  const { borderRadiusInPixels, borderMode = 'solid' } = props;
  return (
    <Background
      variant={BackgroundVariant.Dots}
      gap={16}
      size={1}
      style={{
        backgroundColor: ReactFlowBackgroundColor,
        border: borderMode === 'solid' ? '1px solid #ccc' : 'none',
        borderRadius: borderRadiusInPixels ? `${borderRadiusInPixels}px` : undefined,
      }}
    />
  );
}
